
<div class="mobileNavBar">

  @for(tab of tabs; track $index){
    <div [routerLink]="[tab.route]" [class.marked]="activeTab === tab.route.replace('./', '')">
        <span>
        {{tab.label}}
      </span>
    </div>
}
</div>

<router-outlet></router-outlet>
